import useNavigation from '../../hooks/use-navigation'
import React, {useCallback} from 'react'
import {Flex, Image, Link} from '@chakra-ui/react'
import PropTypes from 'prop-types'

const TeaserItem = ({label, image, image_alt, link, itemRef}) => {
    const navigate = useNavigation()

    const onClick = useCallback(
        (event) => {
            navigate(link)
            event.preventDefault()
        },
        [link, navigate]
    )

    return (
        <Flex
            flexDirection={{base: 'row', lg: 'column'}}
            alignItems={{base: 'center', lg: 'flex-start'}}
            justifyContent="flex-start"
            gap={{base: 4, lg: 3}}
            paddingInlineEnd={{base: 4, lg: 0}}
            onClick={onClick}
            {...(link ? {cursor: 'pointer'} : {cursor: 'inherit'})}
        >
            <Image
                width="auto"
                height={{base: '9.375rem', lg: 'auto'}}
                objectFit="cover"
                // fix for the added padding on the link component for the underline
                marginBottom="calc(var(--chakra-space-linkUnderlineOffset) / -2)"
                src={image}
                alt={image_alt ? image_alt : ''}
            />

            <Link
                size="sm"
                href={link}
                // keep in line with image size above
                maxWidth={{lg: '12.5rem', '2xl': '14.625rem'}}
                ref={itemRef}
                onClick={onClick}
            >
                {label}
            </Link>
        </Flex>
    )
}

TeaserItem.propTypes = {
    label: PropTypes.string,
    image: PropTypes.string,
    image_alt: PropTypes.string,
    link: PropTypes.string,
    itemRef: PropTypes.object
}

export default TeaserItem
